const helpTextEnglish = {
    map: {
        title: 'Map view of project distribution across wards',
        projects:
            'The map shows the total number of projects distributed across the wards. The more saturated and brighter the color, more is the number of projects.',
        budget:
            'The map shows the total budget amount (in NRs.) distributed across the wards for each project. The more saturated and brighter the color, more is the budget amount.'
    },
    barChart: {
        title: 'Bar view of project distribution across wards',
        projects:
            'The bar chart shows the total number of projects distributed across the wards.',
        budget:
            'The bar chart shows the total budget amount (in NRs.) distributed across the wards.'
    },
    radialChart: {
        social: {
            title: 'Radial bar view of social type',
            helpText: 'tooltip text',
        },
        infrastructure: {
            title: 'Radial bar view of infrastructure type',
            helpText: 'tooltip text',
        },
    },
    wardChart: {
        social: {
            title: 'Ward wise bar view of social type',
            helpText: 'tooltip text',
        },
        infrastructure: {
            title: 'Ward wise bar view of infrastructure type',
            helpText: 'tooltip text',
        },
    },
    lineChart:
        'The line chart shows the total number of projects distributed across the wards according to the month of a particular year.',
    progressBar:
        'The progress bar chart compares the total budget with the expenditure used by the projects across the wards.',
    circularProgressBar:
        'The circular chart shows the progress of the projects distributed across the wards. The progress is categorised as physical and financial progress.',
    dotChart:
        'The dotted plot chart compares the type of projects being distributed across the wards. The type of the project is categorised as contractor and user committee projects. Each dot/ circle in the chart represents a project.}',
    biddersText:
        'The total number of bidders is seen who submitted their bids or competed in obtaining the projects. It is applicable for the projects that are carried out by contractors.',
    projectStatus:
        'The pie chart shows the total number of projects distributed across the wards.'
};

const helpTextNepali = {
    map: {
        title: 'वडागत रुपमा वितरित कूल परियाेजनाहरुको नक्सा',
        projects:
            'यस नक्साले वडागत रुपमा वितरित कूल परियाेजनाहरुलाई देखाउँदछ । त्यसमा देखिएकाे रंग जति गाढा र उज्यालाे देखिन्छ, परियाेजनाकाे संख्या त्यति नै बढी हुन्छ । ',
        budget:
            'यस नक्साले वडागत रुपमा वितरित प्रत्येक परियाेजनाकाे कुल बजेटलाई देखाउँदछ । त्यसमा देखिएकाे रंग जति गाढा र उज्यालाे देखिन्छ, परियाेजनाकाे संख्या त्यति नै बढी हुन्छ । '
    },
    barChart: {
        title: 'वडागत रुपमा वितरित कूल परियाेजनाहरुको बार',
        projects: 'Bar Chart ले वडागत रुपमा वितरित कूल परियाेजनाहरुलाई देखाउँदछ ।',
        budget: 'Bar Chart ले वडागत रुपमा विनियाेजित कुल बजेट (नेरु) लाई देखाउँदछ ।'
    },
    radialChart: {
        social: {
            title: 'Radial bar view of social type',
            helpText: 'tooltip text',
        },
        infrastructure: {
            title: 'Radial bar view of infrastructure type',
            helpText: 'tooltip text',
        },
    },
    wardChart: {
        social: {
            title: 'Ward wise bar view of social type',
            helpText: 'tooltip text',
        },
        infrastructure: {
            title: 'Ward wise bar view of infrastructure type',
            helpText: 'tooltip text',
        },
    },
    lineChart:
        'Line Chart ले कुनै आर्थिक वर्षका विभिन्न महिनाहरुमा वडागत रुपमा वितरित कूल परियाेजनाहरुलाई देखाउँदछ ।',
    progressBar:
        'Progress Bar ले वडागत रुपमा कूल बजेटमध्ये खर्च भएकाे जम्मा रकमबीच तुलना गर्दछ ।',
    circularProgressBar:
        'Circular Chart ले वडागत रुपमा वितरित कूल परियाेजनाकाे प्रगतिलाई देखाउँदछ । त्यस्ताे प्रगतिलाई भाैतिक प्रगति एवं वित्तीय प्रगती गरी दुई वर्गमा विभक्त गरिएकाे छ । ',
    dotChart:
        'Dotted Plot Chart ले वडागत रुपमा वितरित परियाेजनाकाे प्रकारका आधारमा तीनकाे तुलना गर्दछ । परियाेजनाकाे प्रकारलाई निर्माण व्यवसायीबाट सञ्चालित परियाेजना एवं उपभाेक्ता समितिबाट सञ्चालित परियाेजना गरी दुई वर्गमा विभक्त गरिएकाे छ ।  चार्टमा रहेकाे प्रत्येक थाेप्लाे/वृत्तले एउटा परियाेजनालाई जनाउँदछ।}',
    biddersText:
        'परियाेजना हासिल गर्नका लागि प्रतिस्पर्धामा भाग लिएका कूल बाेलपत्रदाताकाे संख्या । तर, संख्या निर्माण व्यवसायीबाट कार्यान्वयन हुने परियाेजनाहरुकाे हकमा मात्र लागू हुन्छ ।',
    projectStatus:
        'यस pie chart ले वडागत रुपमा वितरित कूल परियाेजनाहरुलाई देखाउँदछ'
};

export {helpTextEnglish, helpTextNepali};



// WEBPACK FOOTER //
// ./src/localization/helpText.js